import script from "./Plant.vue?vue&type=script&setup=true&lang=js"
export * from "./Plant.vue?vue&type=script&setup=true&lang=js"

import "./Plant.vue?vue&type=style&index=0&id=56fa1374&lang=less&scoped=true"
script.__scopeId = "data-v-56fa1374"

export default script